import { RESET_USERS } from '../types'
export const resetusers = () => {

    return (dispatch) => {
        dispatch({ type: RESET_USERS });
    }
}